import { useHistory } from 'react-router';
import { Drawer } from 'antd';
import './SideMenu.styles.scss';

type PropsType = {
  visible: boolean;
  onClose: () => void;
};

const drawerStyle = {
  bodyStyle: {
    background: '#000',
    paddingTop: 50,
  },
};

const SideMenu = ({ visible, onClose }: PropsType) => {
  const history = useHistory();

  const redirectToPage = (page: string) => {
    switch (page) {
      case 'home':
        history.push('/');
        return;
      case 'faq':
        history.push('/b/faq');
        return;
      case 'create':
        history.push('/create');
        return;
      default:
        return;
    }
  };

  return (
    <Drawer
      className='side-menu'
      visible={visible}
      placement='left'
      onClose={onClose}
      bodyStyle={drawerStyle.bodyStyle}>
      <div className='menu-item' onClick={() => redirectToPage('home')}>
        Homepage
      </div>
      <div className='menu-item' onClick={() => redirectToPage('faq')}>
        FAQ
      </div>
      <div className='menu-item' onClick={() => redirectToPage('create')}>
        Create Party
      </div>
    </Drawer>
  );
};

export default SideMenu;
